import styled from "styled-components";
import { colors } from "../../styles/colors";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || colors.button.primary};
  color: ${(p) => (p.color ? colors.text.primary : colors.text.primary)};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid ${colors.neutral.white};
  border-radius: 4px;
  padding: 13px 0;
  cursor: pointer;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px ${colors.shadow.primary};
  user-select: none;

  &:hover{
    box-shadow: 0 16px 30px ${colors.shadow.hover};
  },
  &:active,
  &:focus {
    color: ${colors.text.secondary};
    border: 1px solid ${colors.neutral.white};
    background-color: ${colors.neutral.white};
  }
`;
